import PropTypes from 'prop-types';
import React from 'react';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { TitleSummary } from '../../style';

export const SimpleListComponent = ({ field, onEdit }) => {
  return (
    <>
      <React.Fragment key={field.idInput}>
        <TitleSummary>{field.label}</TitleSummary>
        <p>
          {field.value}
          {onEdit != null ? <ButtonEditSummaryItem onClick={onEdit} /> : null}
        </p>
      </React.Fragment>
    </>
  );
};

SimpleListComponent.propTypes = {
  field: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
};
